import { DocumentServicesObject, CompRef } from '@wix/document-services-types';
import { EventType } from '@wix/editor-platform-sdk-types';
import { ComponentsService } from '@wix/editor-platform-manifest-services';
import { parseHostEvent } from './utils';

export function initStateResetHandler(
  documentServicesAPI: DocumentServicesObject,
  componentsService: ComponentsService,
) {
  let shouldSkipSelectionChangedEvent = false;

  documentServicesAPI.platform.subscribeOnCustomAppEvents((event) => {
    const hostEvent = parseHostEvent<{ componentRefs: CompRef[] }>(event);
    const eventType = hostEvent.eventType;

    switch (eventType) {
      case EventType.componentSelectionChanged:
        if (!hostEvent.componentRefs?.length) {
          break;
        }

        if (shouldSkipSelectionChangedEvent) {
          shouldSkipSelectionChangedEvent = false;
          return;
        }

        componentsService.states.reconcileStatesOnComponentSelection(
          hostEvent.componentRefs,
        );
        break;

      case EventType.appRefreshCompleted:
        shouldSkipSelectionChangedEvent = true;
        break;
    }
  });
}
